import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_10: R2BReferralBrandEntity = {
  token: "r2b_referral_10",
  type: "r2bReferralBrand",
  name: "Bloom & Petal",
  email: "david.chen@example.com",
  website: "bloompetal.com",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
